export default __webpack_public_path__ + "static/media/color.571a1ee2.svg";